import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import '../utils/RendicionCuentas.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPenToSquare} from '@fortawesome/free-solid-svg-icons';

const API_URL_RENDICION = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/ingreso-egreso`
  : 'http://localhost:4000/ingreso-egreso';

const RendicionCuentas = () => {
  const [registros, setRegistros] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [searchCode, setSearchCode] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [newRegistro, setNewRegistro] = useState({
    tipo: 'Ingreso',
    cantidad: '',
    descripcion: '',
    precio_unitario: '',
    precio_total: '',
    fecha: '',
  });

useEffect(() => {
  if (searchCode === '') {
    fetchRegistros(); // Si el input está vacío, carga todos
  } else {
    fetchRegistrosPorTipo(searchCode);
  }
}, [searchCode]);


  const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const fetchRegistros = async () => {
    try {
      const headers = getAuthHeaders();
      const response = await axios.get(API_URL_RENDICION, { headers });
      const registrosNumericos = response.data.map(reg => ({
        ...reg,
        precio_unitario: Number(reg.precio_unitario),
        precio_total: Number(reg.precio_total),
      }));

      // Aquí se invierte el orden para que los más nuevos aparezcan al inicio
      setRegistros(registrosNumericos.reverse());
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchRegistrosPorTipo = async (tipo) => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.get(`${API_URL_RENDICION}/tipo`, {
      headers,
      params: { tipo },
    });
    const registrosNumericos = response.data.map(reg => ({
      ...reg,
      precio_unitario: Number(reg.precio_unitario),
      precio_total: Number(reg.precio_total),
    }));
    setRegistros(registrosNumericos);
  } catch (error) {
    console.error('Error fetching filtered data:', error);
    setRegistros([]); // Vaciar si error o no resultados
  }
};

const handleSearch = (e) => {
  e.preventDefault();
  // Ya no se necesita hacer nada aquí
};


  const handleOpenModal = () => setShowModal(true);

  const handleCloseModal = () => {
    setShowModal(false);
    setIsEditing(false);
    setEditingId(null);
    setNewRegistro({
      tipo: 'Ingreso',
      cantidad: 0,
      descripcion: '',
      precio_unitario: 0,
      precio_total: 0,
      fecha: '',
    });
    setErrorMessage('');
  };

  const calcularTotal = (cantidad, precio_unitario) => {
    return cantidad * precio_unitario;
  };

  const handleAddRegistro = async (e) => {
    e.preventDefault();

    const { tipo, cantidad, descripcion, precio_unitario, fecha } = newRegistro;
    const precio_total = calcularTotal(cantidad, precio_unitario);

    if (!descripcion || cantidad <= 0 || precio_unitario <= 0 || !fecha) {
      setErrorMessage('Todos los campos deben ser válidos y la fecha no debe estar vacía.');
      return;
    }

    try {
      const headers = getAuthHeaders();

      if (isEditing && editingId) {
        // Editar registro existente
        await axios.put(`${API_URL_RENDICION}/${editingId}`, { ...newRegistro, precio_total }, { headers });
      } else {
        // Agregar nuevo registro
        await axios.post(API_URL_RENDICION, { ...newRegistro, precio_total }, { headers });
      }

      fetchRegistros();
      handleCloseModal();
    } catch (error) {
      console.error('Error al guardar el registro:', error);
      setErrorMessage('Error al guardar el registro.');
    }
  };

  const handleEditRegistro = (registro) => {
    setIsEditing(true);
    setEditingId(registro.idIngresoEgreso); // Ajusta esta propiedad según el ID que use tu API
    setNewRegistro({
      tipo: registro.tipo,
      cantidad: registro.cantidad,
      descripcion: registro.descripcion,
      precio_unitario: registro.precio_unitario,
      precio_total: registro.precio_total,
      fecha: registro.fecha.split('T')[0], // Para que la fecha quede en formato yyyy-mm-dd
    });
    setShowModal(true);
  };

  const handleDeleteRegistro = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este registro?')) {
      try {
        const headers = getAuthHeaders();
        await axios.delete(`${API_URL_RENDICION}/${id}`, { headers });
        fetchRegistros();
      } catch (error) {
        console.error('Error al eliminar el registro:', error);
      }
    }
  };

  return (
    <div className="rendicion-panel">
      <div className="header-buttons">
        <Button variant="success" onClick={handleOpenModal}>+ Nuevo Registro</Button>
      </div>

      <h2>Libro Contable</h2>

      <Form onSubmit={handleSearch} className="search-form">
        <Form.Control
          type="text"
          value={searchCode}
          onChange={(e) => setSearchCode(e.target.value)}
          placeholder="Buscar por ingreso o egreso"
        />
        <Button variant="secondary" type="submit">Buscar</Button>
      </Form>
      <div className="rendicion-tabla-scroll">
      <table className="rendicion-table">
        <thead>
          <tr>
            <th>N</th>
            <th>Tipo</th>
            <th>Cantidad</th>
            <th>Descripción</th>
            <th>Precio Unitario</th>
            <th>Precio Total</th>
            <th>Fecha</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {registros.map((reg, idx) => (
            <tr key={idx}>
              <td>{registros.length - idx}</td>
              <td>{reg.tipo}</td>
              <td>{reg.cantidad}</td>
              <td>{reg.descripcion}</td>
              <td>${reg.precio_unitario.toFixed(2)}</td>
              <td>${reg.precio_total.toFixed(2)}</td>
              <td>{new Date(reg.fecha).toLocaleDateString()}</td>
              <td>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => handleEditRegistro(reg)}
                  style={{ marginRight: '0.5rem' }}
                ><FontAwesomeIcon icon={faPenToSquare} />
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDeleteRegistro(reg.idIngresoEgreso)}
                ><FontAwesomeIcon icon={faTrash} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Editar Registro' : 'Agregar Registro'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
          <Form onSubmit={handleAddRegistro}>
            <Form.Group>
              <Form.Label>Tipo</Form.Label>
              <Form.Control
                as="select"
                value={newRegistro.tipo}
                onChange={(e) => setNewRegistro({ ...newRegistro, tipo: e.target.value })}
              >
                <option value="Ingreso">Ingreso</option>
                <option value="Egreso">Egreso</option>
                <option value="Deudas por cobrar">Deudas por cobrar</option>
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Descripción</Form.Label>
              <Form.Control
                type="text"
                value={newRegistro.descripcion}
                onChange={(e) => setNewRegistro({ ...newRegistro, descripcion: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Cantidad</Form.Label>
              <Form.Control
                type="number"
                value={newRegistro.cantidad}
                onChange={(e) => {
                  const cantidad = parseFloat(e.target.value);
                  setNewRegistro({
                    ...newRegistro,
                    cantidad,
                    precio_total: calcularTotal(cantidad, newRegistro.precio_unitario),
                  });
                }}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Precio Unitario</Form.Label>
              <Form.Control
                type="number"
                value={newRegistro.precio_unitario}
                onChange={(e) => {
                  const precio_unitario = parseFloat(e.target.value);
                  setNewRegistro({
                    ...newRegistro,
                    precio_unitario,
                    precio_total: calcularTotal(newRegistro.cantidad, precio_unitario),
                  });
                }}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Precio Total</Form.Label>
              <Form.Control
                type="number"
                value={newRegistro.precio_total}
                readOnly
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Fecha</Form.Label>
              <Form.Control
                type="date"
                value={newRegistro.fecha}
                onChange={(e) => setNewRegistro({ ...newRegistro, fecha: e.target.value })}
                required
              />
            </Form.Group> <br />
            <Button variant="primary" type="submit">{isEditing ? 'Guardar Cambios' : 'Agregar'}</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default RendicionCuentas;
